import type { UseFetchOptions } from '#app'

interface Endpoints {
  baseURL?: string
  login: string
  logout?: string
  refresh: string
  me?: string
}

interface UseAuthFetchOptions extends UseFetchOptions<any> {
  strategy?: string
}

export const useAuthFetch = async (endpoint: string, options: UseAuthFetchOptions = {}) => {
  const { currentStrategy, login, logout, getRefreshToken, status, token } = useAuth(options.strategy)
  const ENDPOINTS = currentStrategy?.endpoints as Endpoints
  const baseURL: string | undefined = ENDPOINTS?.baseURL
  if (import.meta.client) {
    return new Promise(async (resolve, reject) => {
      try {
        const headers = { ...(options.headers || {}) }
        if (status.value === 'authenticated') {
          // @ts-ignore
          headers['Authorization'] = `Bearer ${token.value?.access}`
        }

        try {
          const response = await $fetch(endpoint, {
            // @ts-ignore
            baseURL,
            ...options,
            // @ts-ignore
            headers
          })
          resolve(response)
        } catch (error) {
          throw new Error('Error', { cause: error })
        }
      } catch (error: any) {
        if (_getErrorStatus(error) === 401 && !endpoint.includes(ENDPOINTS.refresh)) {
          try {
            if (token.value && token.value.refresh !== null) {
              await getRefreshToken()
              await login()
              resolve(await useAuthFetch(endpoint, options))
            } else throw new Error(_getError(error))
          } catch (e) {
            if (_getErrorStatus(error) === 401) resolve(logout())
            reject(_getError(error))
          }
        } else reject(_getError(error))
      }
    })
  }

  function _getError(error: any) {
    return error?.cause || error || {}
  }

  function _getErrorStatus(error: any) {
    return error?.cause?.status || error?.status || error?.cause?.statusCode || error?.statusCode
  }
}
